import React from 'react';

export const MagnifyGlass = ({ color }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0058 19.0669L19.0732 21.0001L14.1111 16.0374L16.075 14.1367L21.0058 19.0669Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.22212 1C11.4027 1 13.4939 1.86618 15.0358 3.40799C16.5778 4.94981 17.4441 7.04099 17.4442 9.22152C17.4442 11.4022 16.578 13.4935 15.036 15.0354C13.4941 16.5774 11.4028 17.4436 9.22212 17.4436C7.04148 17.4436 4.95015 16.5774 3.4082 15.0354C1.86626 13.4935 1 11.4022 1 9.22152C1.00016 7.04099 1.86649 4.94981 3.40842 3.40799C4.95035 1.86618 7.04158 1 9.22212 1V1Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.144 3.3291C10.722 3.3291 12.2354 3.95592 13.3513 5.07169C14.4671 6.18746 15.0941 7.70078 15.0943 9.27879"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
